var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    color: "currentColor",
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1301 10.6517C20.1301 10.6517 19.5644 18.2286 19.2363 21.4202C19.0801 22.9446 18.2082 23.8379 16.7801 23.866C14.0624 23.9189 11.3415 23.9222 8.62486 23.8604C7.2509 23.83 6.39361 22.9255 6.24049 21.4281C5.91028 18.2084 5.34778 10.6517 5.34778 10.6517",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.571 7.01966H3.90643",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1673 7.01966C17.3496 7.01966 16.6454 6.39529 16.485 5.53016L16.2319 4.16216C16.0756 3.53104 15.5465 3.09454 14.9433 3.09454H10.534C9.93083 3.09454 9.40166 3.53104 9.24541 4.16216L8.99229 5.53016C8.83187 6.39529 8.12771 7.01966 7.31 7.01966",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.53390e3a.svg";
export { ForwardRef as ReactComponent };